export default "__VITE_ASSET__DQiJIa6L__"